import { makeStyles } from '@material-ui/core/styles';

export const useControlledSelectStyles = makeStyles((theme) => ({
  placeholder: {
    color: theme.palette.grey[500],
  },
}));
